import { useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys } from '../api/dashboard.api';

/**
 * TZ Lot 1 §7.1 / §8.2 — "high share of expensive roles" alert.
 *
 * Not period-scoped: an alert reports the state of active Fixed Fee cases right
 * now. The rule already existed as a daily notification cron; the 2026-07-26
 * review recorded it as absent from the dashboard, which this feeds.
 */
export function useMDExpensiveRoles() {
  return useQuery({
    queryKey: dashboardQueryKeys.mdExpensiveRoles(),
    queryFn: () => dashboardApi.getMDExpensiveRoles(),
  });
}
